<app-navbar></app-navbar>
<div class=" pt-0 px-2">
    <div class="container-fluid">
        <div class="row  m-0 ">
            <div class="col-md-12  m-0">
                <div class="row m-0 ">
                    <div class="col-12  m-0 col-md-12 text-center text-primary">
                        <h4 class="m-0  text-bold">PLATAFORMA</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class=" mt-2 px-2">
    <div class="container-fluid">
        <div class="row linhabaias">
            <div class="col-12 p-2 m-0 text-center">Carregando...</div>
        </div>
        <div class="row px-1">
            <div class="col-md-12 m-0 ">
                <hr class="m-0  py-1" />
                <div class="table-responsive">
                    <table class="table m-0 " id="tabFila">
                        <thead>
                            <tr>
                                <th class="text-center w-5" style="font-weight: bold !important;">#</th>
                                <th class="text-center w-10" style="font-weight: bold !important;">PLACA</th>
                                <th class="text-center w-15" style="font-weight: bold !important;">TIPO</th>
                                <th class="text-center w-15" style="font-weight: bold !important;">ENTRADA</th>
                                <th class="text-center w-15" style="font-weight: bold !important;">PLATAFORMA</th>
                                <th class="text-center w-10" style="font-weight: bold !important;"><i class="far fa-clock fa-lg"></i></th>
                                <th class="text-center w-10" style="font-weight: bold !important;">BAIA</th>
                                <th class="text-center w-15" style="font-weight: bold !important;">AÇÕES</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Os dados serão carregados via DataTables -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>